import { DEFAULT_FILL_OPACITY } from '../../core/constants.js';
import { ShapeColor, ColorToken } from '../../core/types/color-palette.js';
import { getOpacity } from '../../core/utils/getOpacity.js';
import { ColoredChartDimension } from '../types/categorical-bar-chart-data.js';

export const getBarStyle = (
  key: string,
  color: ColorToken,
  highlightedDimension: ColoredChartDimension | undefined,
): ShapeColor => {
  if (!highlightedDimension) {
    return { color: color.Default, opacity: DEFAULT_FILL_OPACITY };
  }

  const isCurrentHighlighted = highlightedDimension.name === key;

  return {
    color: color.Default,
    opacity: getOpacity(isCurrentHighlighted),
  };
};
